import { useAuth } from './useAuth'

/**
 * Returns the day of the week that the week starts on for the current user.
 * Defaults to 'sunday' if not set.  If the user is not authenticated,
 * which should really never be the case, it will also default to 'sunday'.
 */
export const useWeekStartsOn = () => {
  const { user } = useAuth()

  return user?.weekStartsOn ?? 'sunday'
}
